import FAQTable from "./page/FAQTable";

const FAQ:React.FC = () => {
    return (
        <div><FAQTable/></div>
    )
};
export default FAQ;